/**
 * Instant add + themed info sheet for patch cards on search and collections.
 */
(function () {
  const addUrl =
    (window.TAY_ROUTES && window.TAY_ROUTES.cartAdd) || '/cart/add.js';

  function closestCard(el) {
    return el instanceof Element ? el.closest('[data-patch-quick]') : null;
  }

  function sheetOf(card) {
    return card ? card.querySelector('[data-patch-sheet]') : null;
  }

  function showToast(message) {
    let toast = document.querySelector('[data-patch-quick-toast]');
    if (!(toast instanceof HTMLElement)) {
      toast = document.createElement('div');
      toast.className = 'bbs-patch-shop__toast';
      toast.setAttribute('data-patch-quick-toast', '');
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      toast.remove();
    }, 1400);
  }

  function openSheet(card) {
    closeAll();
    const sheet = sheetOf(card);
    if (!sheet) return;
    sheet.hidden = false;
    sheet.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const closeBtn = sheet.querySelector('[data-patch-action="close-info"]');
    if (closeBtn instanceof HTMLElement) closeBtn.focus();
  }

  function closeSheet(card) {
    const sheet = sheetOf(card);
    if (!sheet) return;
    sheet.hidden = true;
    sheet.classList.remove('is-open');
    if (!document.querySelector('[data-patch-sheet].is-open')) {
      document.body.style.removeProperty('overflow');
    }
  }

  function closeAll() {
    document.querySelectorAll('[data-patch-sheet]').forEach((sheet) => {
      sheet.hidden = true;
      sheet.classList.remove('is-open');
    });
    document.body.style.removeProperty('overflow');
  }

  async function addPatch(card, button) {
    const variantId = Number(card.getAttribute('data-variant-id'));
    const title = card.getAttribute('data-product-title') || 'Item';
    const orderType = card.getAttribute('data-order-type') || 'Patches only';
    const itemProp = card.getAttribute('data-item-prop') || 'Patch';
    const kind = card.getAttribute('data-shop-kind') || 'patch';
    const noun = kind === 'pin' ? 'bag pin' : kind === 'sticker' ? 'sticker' : 'patch';
    if (!variantId) return;
    const fx = window.TAY_patchCartFx;
    const sheet = sheetOf(card);
    const sheetOpen = Boolean(sheet && sheet.classList.contains('is-open'));
    const imageUrl = fx
      ? fx.imageFrom(card) || card.getAttribute('data-image') || ''
      : card.getAttribute('data-image') || '';
    const fromRect =
      button instanceof Element ? button.getBoundingClientRect() : null;
    if (button instanceof HTMLButtonElement) {
      button.disabled = true;
    }
    try {
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                'Order type': orderType,
                [itemProp]: title.slice(0, 200),
              },
            },
          ],
        }),
      });
      const data = await response.json();
      if (data.status) {
        showToast(data.message || `Could not add that ${noun}.`);
        if (button instanceof HTMLButtonElement) button.disabled = false;
        return;
      }
      document.dispatchEvent(
        new CustomEvent('tay:cart-updated', {
          bubbles: true,
          detail: { itemCount: data.item_count, open: true },
        })
      );
      if (fx) {
        fx.flyToCart({ imageUrl, fromRect, fromEl: button });
        if (button instanceof HTMLButtonElement) {
          fx.confirmButton(button, { restoreMs: sheetOpen ? 700 : 1400 });
        }
      } else {
        showToast(`Added ${title}`);
        if (button instanceof HTMLButtonElement) button.disabled = false;
      }
      if (sheetOpen) {
        window.setTimeout(() => closeSheet(card), 600);
      }
    } catch {
      showToast(`Could not add that ${noun}. Please try again.`);
      if (button instanceof HTMLButtonElement) button.disabled = false;
    }
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const actionEl = target.closest('[data-patch-action]');
    if (!(actionEl instanceof HTMLElement)) return;
    const card = closestCard(actionEl);
    if (!card) return;
    const action = actionEl.getAttribute('data-patch-action');
    if (action === 'info') {
      openSheet(card);
      return;
    }
    if (action === 'close-info') {
      closeSheet(card);
      return;
    }
    if (action === 'add') {
      addPatch(card, actionEl);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();
